import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {slotStore} from '../../globals';
import {InfoSystemData} from '@gongxigames/framework/slotV2/modules/infoSystem';

export class DisabledUIDataWaitAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'DisabledUIState');

        const name = slotStore.disabledUIModeDataName.value;

        if (name) {
            const currentData = slotStore.infoSystemData.value?.get(name);

            if (currentData?.name === name) {
                this.emitter.emit('UI.command.infoSystem.show');
                this.onExecuted?.();
            } else {
                this.emitter.emit('UI.command.infoSystem.wait');

                this.emitter.on('Game.command.showInfo', (data: InfoSystemData) => {
                    slotStore.infoSystemData.value.set(data.name, data);
                    this.emitter.emit('UI.command.infoSystem.show');

                    this.onExecuted?.();
                });
            }
        } else {
            this.onExecuted?.();
        }
    }

    getName(): string {
        return 'DisabledUIDataWaitAct';
    }
}